// extracted by mini-css-extract-plugin
export default {"Container":"LegendTop_Container__-hBzu","Item":"LegendTop_Item__g9aM1","Title":"LegendTop_Title__pI2C+"};